// extracted by mini-css-extract-plugin
module.exports = {"container":"TypeformEmbed_container__TOjWb","tall":"TypeformEmbed_tall__vX_gx","short":"TypeformEmbed_short__OfcU9"};